import { usePowtoonAuth } from "@/lib/auth/PowtoonAuthContext";
import type { Permission } from "@/lib/powtoon-be/types";

export function useAuth() {
  const { user, isLoading, isAuthenticated } = usePowtoonAuth();
  const permissions: Permission[] = [];
  if (isAuthenticated && user) {
    if (user.permissions?.canView || user.permissions?.canEdit) {
      permissions.push("live-avatars.view");
    }
    if (user.permissions?.canEdit) {
      permissions.push("live-avatars.train");
    }
  }
  return {
    isLoading,
    user: user
      ? {
          id: String(user.powtoonUserId),
          name: user.displayName ?? user.email,
          email: user.email,
          powtoonUserId: user.powtoonUserId,
        }
      : null,
    permissions,
    hasPermission: (p: Permission) => permissions.includes(p),
    refetch: () => Promise.resolve(),
  };
}
